import React from "react";

export const Label = ({ text, color = "gray", className }) => {
  return (
    <div className={`${className ? className : ""} global-label-container`}>
      <div className={` global-label global-label-bg-${color}`}>{text}</div>
    </div>
  );
};
